<template>
    <div>
        <SearchAutocomplete
            v-model="selected"
            :set-value="setValue"
            :api-endpoint="searchQuery => `/api/tags?search=${searchQuery}&type=${type}${model ? `&model=${model}` : ''}`"
            :label="label"
            :initial-data="initialData"
            :placeholder="placeholder"
            :include-icon="includeIcon ? 'filter' : ''"
            keep-first
            field="slug.en"
            open-on-focus
            url-params="tags"
            @esc="$emit('update:modelValue', null)"
            @selected="tag => $emit('update:modelValue', tag)"
            @clear="$emit('update:modelValue', null)"
        >
            <template #item="{ itemData }">
                {{ itemData.option.slug.en }}
            </template>
        </SearchAutocomplete>

        <div v-if="error" class="error-message">{{ error }}</div>
    </div>
</template>

<script>
import SearchAutocomplete from '@/components/autocomplete/Autocomplete.vue';
import axios from '@/plugins/axios.js';

export default {
    name: 'TagSearch',

    components: { SearchAutocomplete },

    props: {
        type: {
            type: String,
            required: true,
        },

        model: {
            type: String,
            required: false,
            default: null,
        },

        label: {
            type: String,
            required: false,
            default: '',
        },

        placeholder: {
            type: String,
            required: false,
            default: '',
        },

        modelValue: {
            type: Object,
            required: false,
            default: () => ({}),
        },

        initialData: {
            type: Array,
            required: false,
            default: () => [],
        },

        setValue: {
            type: String,
            required: false,
            default: null,
        },

        presetId: {
            type: Number,
            required: false,
            default: null,
        },

        includeIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    emits: ['update:modelValue'],

    data: () => ({
        selected: null,
        error: null,
    }),

    created() {
        if (this.presetId) {
            this.setInitialData();
        }
    },

    methods: {
        async setInitialData() {
            try {
                const { data } = await axios.get(`/api/tags/${this.presetId}`);

                this.selected = data.data;
                this.$emit('update:modelValue', data.data);
                this.error = null;
            } catch (error) {
                this.error = 'Failed to fetch tags. Please try again.';
                console.error(error);
            }
        },
    },
};
</script>

<style>
.error-message {
    color: red; /* Style the error message */
    margin-top: 0.5rem;
}
</style>
